import {css} from '@emotion/react';
import styled from '@emotion/styled';

type SeasonalInterceptorProps = {
  interceptorImageSmall?: string;
  interceptorImageLarge?: string;
};

export const SeasonalInterceptor = styled.div<SeasonalInterceptorProps>(
  ({theme, interceptorImageSmall, interceptorImageLarge}) => css`
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    background-position: center center;

    ${interceptorImageSmall &&
    css`
      background-image: ${`url(${interceptorImageSmall})`};
      width: 130px;
      height: 70px;
    `}

    ${interceptorImageLarge &&
    theme.respondTo(
      'md',
      css`
        background-image: ${`url(${interceptorImageLarge})`};
        width: 200px;
        height: 70px;
      `
    )}
  `
);
